import { render } from "./ConfiguracionComunicaciones.vue?vue&type=template&id=6999f38c"
import script from "./ConfiguracionComunicaciones.vue?vue&type=script&lang=js"
export * from "./ConfiguracionComunicaciones.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__